import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';

import GeneralRemarks from './GeneralRemarks';

interface GeneralRemarkshContainerProps {
  poAwb: GhaPickupStatusAwb;
  doNumber: string;
  code: string;
  number: string;
  setStatePoAwb: (poAwb: GhaPickupStatusAwb) => void;
  receiveError: Function;
  onlyRead?: boolean;
};

interface GeneralRemarksContainerState {
  generalRemarks: string;
  customerError: boolean;
  remarksError: boolean;
};

class GeneralRemarksContainer extends Component<GeneralRemarkshContainerProps, GeneralRemarksContainerState> {

  state = {
    generalRemarks: '',
    customerError: false,
    remarksError: false
  };

  componentDidUpdate(prevProps: GeneralRemarkshContainerProps) {

    if (prevProps.poAwb.general_remarks !== this.props.poAwb.general_remarks) {

      const generalRemarks: string = !this.props.poAwb.general_remarks ? '' : this.props.poAwb.general_remarks;
      const customerError: boolean = this.props.poAwb.customer_error;
      this.setState({ generalRemarks, customerError });
    }
  }

  handleChange = (event: any, type: string): void => {
 
    const value: string = event.target.value;
    let generalRemarks = this.state.generalRemarks;
    let customerError = this.state.customerError;
    let remarksError = this.state.remarksError;
    if(type === 'remarks') {
      remarksError = false;
      generalRemarks = value
    } else if(type === 'ce') {
      customerError = generalRemarks && !customerError ? true : false;
      if(!generalRemarks) {
        remarksError = true;
      } else {
        remarksError = false;
      }
    }
    this.setState({ generalRemarks, customerError, remarksError }, () => {
      if(type === 'ce')
        this.handleSetRemarks();
    });

  }

  handleSetRemarks = (): void => {
   
    const data: {'general_remarks': string, 'customer_error': boolean } = {'general_remarks' : this.state.generalRemarks, 'customer_error': this.state.customerError };

    if (data.general_remarks === undefined) {
      return;
    }

    pickupOrderRemote.savePoAwbRemarks(this.props.doNumber, this.props.code, this.props.number, data).then((resp: ApiResponse<boolean>) => {
    
      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {

        const poAwb: GhaPickupStatusAwb = { ... this.props.poAwb };
        
        poAwb.general_remarks = this.state.generalRemarks;
        poAwb.customer_error = this.state.customerError;
        this.props.setStatePoAwb(poAwb);

      } else {
        this.setState({ generalRemarks: this.props.poAwb.general_remarks });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });  
  }

  render() {

    return (
      <GeneralRemarks 
        generalRemarks={ this.state.generalRemarks }
        disabled={ !!this.props.onlyRead }
        handleChange={ this.handleChange }
        handleSetRemarks={ this.handleSetRemarks }
        customerError={ this.state.customerError }
        remarksError={ this.state.remarksError }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
}

export default connect(null, mapDispatchToProps)(GeneralRemarksContainer);